// AuthenticationProvider.js
const serverUrl = "/api";
class PaymentProvider {

    async createCoupon(token, gameId, amount, mail, discount_code_id = null, base_price = null) {
        try {
            console.log("createCoupon", token, gameId, amount, mail, discount_code_id, base_price);
            const response = await fetch(serverUrl + '/createCoupon', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                    gameId: gameId,
                    amount: amount,
                    mail: mail,
                    discount_code_id: discount_code_id,
                    base_price: base_price
                }),
            });
            console.log(response);
            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }

    async createGiftVoucher(token, gameId, amount, mail, name, wish, lang) {
        try {
            console.log("createGiftVoucher", token, gameId, amount, mail, name, wish, lang);
            const response = await fetch(serverUrl + '/createGiftVoucher', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                    gameId: gameId,
                    amount: amount,
                    mail: mail,
                    name: name,
                    wish: wish,
                    lang: lang
                }),
            });
            console.log(response);
            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }
    


    async decreaseReferalPoints(token, referral_points) {
        try {
            console.log("decreaseReferalPoints");
            const response = await fetch(serverUrl + '/decreaseReferalPoints', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token, 
                    referralPoints: referral_points,
                }),
            });
            console.log(response);
            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }
}




export default PaymentProvider;
